import { t } from "@/lib/i18n";

function shortHash(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
}

function slugFromDescription(desc: string): string {
  const normalized = desc
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return normalized || `desc_${shortHash(desc)}`;
}

/**
 * Translate a streak mission description.
 * Resolution order:
 * 1) Slug-based key: streakMissions.descriptions.<slugified description>
 * 2) Slug+hash key: streakMissions.descriptions.<slug>_<hash>
 * 3) Fallback: original description
 */
export function translateStreakMissionDescription(
  description: string,
): string {
  const trimmed = description?.trim?.() ?? description;

  const slug = slugFromDescription(trimmed);
  const baseKey = `streakMissions.descriptions.${slug}`;
  let translated = t(baseKey);
  if (translated !== baseKey) return translated;

  const hashKey = `streakMissions.descriptions.${slug}_${shortHash(trimmed)}`;
  translated = t(hashKey);
  if (translated !== hashKey) return translated;

  return description;
}
